export class ApiResponse {
    ErrorMessage: string | null;
    Data: any;
}